@if (!isDesktop && !hideClose) {
  <div class="close-button" style="color: white">
    <button
      appButton
      name="close"
      location="view-annotation"
      spacing="1"
      color="darker-blur"
      height="1"
      (click)="onClose.emit()"
    >
      <app-svg src="/assets/icons/cross.svg"></app-svg>
    </button>
  </div>
}

<canvas #canvas [class.faded]="faded"></canvas>
